
import {
    ABSTRACT_CONCEPT_RESPONSE,
    ABSTRACT_CONCEPT_FAILURE,
    ABSTRACT_CONCEPT_REQUEST,
    ABSTRACT_CONCEPT_CHANGE
 } from '../../actions/types';
 
 const initialState = {
        abstract: "",
        concepts : [],
        isConceptLoading : false
 };
 
 
 const setAbstractRequest = (state, action) => {
    
    return {
        ...state,
        isConceptLoading : true
    }
} 

const setAbstractResponse = (state, action) => {
    let concepts = action.payload.concepts || [];
    
    return {
        ...state,
        concepts,
        isConceptLoading : false
    }
} 

const setAbstractFailure = (state, action) => {
    return {
        ...state,
        concepts:[],
        isConceptLoading : false
    }
} 

const setAbstractChange = (state, action) => {
    const abstract = action.payload.abstract
    return {
        ...state,
        abstract
    }
} 


 export default (state = initialState, action) => {
     switch (action.type) {
        case ABSTRACT_CONCEPT_REQUEST:
            return setAbstractRequest(state, action);
            break;
    
        case ABSTRACT_CONCEPT_RESPONSE:
            return setAbstractResponse(state,action)

        case ABSTRACT_CONCEPT_FAILURE:
            return setAbstractFailure(state,action)
        case ABSTRACT_CONCEPT_CHANGE:
                return setAbstractChange(state, action);
                break;

         default:
             return state;
             break;
     }
 }